import JSEncrypt from "jsencrypt/bin/jsencrypt.min";

const publickKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3DBcWIlPoY/I8ctLjEZN\n' +
'g+blk2rJn35lX9ZZrmHnCyKP8JQbGm26vDnsp5v3v8DHIq24+8f9ov9xmCkImFjk\n' +
'18dJAyB0EpXY/HCKCYUONiQZ7DMHKe1Ncep6Yv51OPAXlLklGe1FsmyZgyCSE9aK\n' +
'P+GG5zo0qgF+G7ntNyIHzqExyKlQ/IJ1mspHGacZ+ryPdOGC5awyWbsP2OWc7Ev3\n' +
'JpMt+1C9rnHNdSWl+F0FaLyBgceKg2FJIa9Kmul3BlLyImsESY2RT0ko8dP/P4OF\n' +
'x7i/l2OHLaOGClePpU55xeRJOF9yO19YFL7y8OB79353guF1RkVHyNEw5n9eKqQx\n' +
'qQIDAQAB'

const privateKey = 'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDcMFxYiU+hj8jx\n'+
'y0uMRk2D5uWTasmffmVf1lmuYecLIo/wlBsabbq8Oeynm/e/wMcirbj7x/2i/3GY\n'+
'KQiYWOTXx0kDIHQSldj8cIoJhQ42JBnsMwcp7U1x6npi/nU48BeUuSUZ7UWybJmD\n'+
'IJIT1oo/4YbnOjSqAX4bue03IgfOoTHIqVD8gnWaykcZpxn6vI904YLlrDJZuw/Y\n'+
'5ZzsS/cmky37UL2ucc11JaX4XQVovIGBx4qDYUkhr0qa6XcGUvIiawRJjZFPSSjx\n'+
'0/8/g4XHuL+XY4cto4YKV4+lTnnF5Ek4X3I7X1gUvvLw4Hv3fneC4XVGRUfI0TDm\n'+
'f14qpDGpAgMBAAECggEAKyZDAoquE0AlJdUsEeo5CI84ECKOLnZLkXNlEbpX16PH\n'+
'R2MOyKgWPwqu6M20yFwT6iTXKmgvuUCL10C7UXeiKPMByN4UQQwigJ3hPypW9Z8v\n'+
'gU0iq0G4uokzwLCS8jyCsn9x2NnZnbSQhNTeK4sQfqJImImchnBScUaHSRWfKAur\n'+
'st57PvqYBpRu94Kp/RVD79mKaOqhn45f/WjItgo04gHIktxZZGsd8KiQPjDY4OnG\n'+
'qDuWaYd//BJL8yRaFuAPTiWC5hoPTpK2AVp26Z7WfKbnE0SU6qRcQ8ZkNph0SL5i\n'+
'yEqKBYfSpz/6OOGnzcdNw14Kacm8C128GmsIBmE3gQKBgQDueWf/hwxUIBdzy6g2\n'+
'oZu9CBsrzPSIEvjwyX7cyIZd0qlcOJR2rQUzN0FvqxuQjWS+jGjM+49yXcVm/gv+\n'+
'EumCvfOAciXv79IFaOeMtLSGOEF1t+X9yT1Xs+CCQ/UqGAY4lwJOarG/MFDIsa9G\n'+
'hV+mQIPeuW3MthagdtbcADnn+QKBgQDsXvBZEGd1wLG326Wtg5m3J3peyBZlZ222\n'+
'xlnuY0zTghCjKhHifOY08lC1qKqzl0Ippz9kjBEyIH86HQdOqxeBugsEwY8cDFMH\n'+
'TvLwt3asQB/tcKtmIE1n9iKyJaLYvBswaPeD2ePpPa2K7MWET+nDyoMbP3BUo+fN\n'+
'hyL89wXjMQKBgF171Ev0Sd30kpz/GhsIcT/CHLyn5LgvD818f7HXHe1Ltr6DI5f+\n'+
'LYqtP4aiAfVBqFuWOUMZ3lrL7aV5M4RPL6DkC7+vf7W2QpOCUzryX8454VdfVtaM\n'+
'+/IUfo8ySrpMnquybuIEq1cyfoieNwKjKCLJKai28hcMzoPq8kFeCVUpAoGBAJpr\n'+
'f7u/4sdj5vbFkVxlMEQej2xibXc79cpFlTUPPH6lZzchYePEUyTd9WpoUXTYaYoK\n'+
'0HhgpU9JObT+h+qWDdpbb51g0pyxVIDezAoE4YuwrOsTA3bJvaggfhRCUDwlz+F1\n'+
'gdZqv+F9wOWUv4ksJ/0YTUS80icJmYOFOI9o1jjRAoGBAOarggEE0BM1VQqSYJbN\n'+
'Tso2qYR5gqsnFkHkl4v2ejUcZhWvcmYNw6xTWIiVZlB0WhLy4/4GiT2LM3KpTdvG\n'+
'DOj0R7uQ0ta/t7EGiCETrL6ofSKG2HYZvEl5VdDNdWAAwx9Z7KsGSIYrEkfCn44r\n'+
'3XOonk5+iNOc7Wsreahv36bs'

export function encrypt(txt){
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publickKey)
    return encryptor.encrypt(txt)
}

export function decrypt(txt){
    const decryptor = new JSEncrypt()
    decryptor.setPrivateKey(privateKey)
    return decryptor.decrypt(txt)
}
